import React from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { ProformaInvoiceForm } from '~/src/components/organisms'
import { ProtectedPage } from '~/src/components/templates'
import { IInvoiceDetail } from '~/src/repositories/Invoice/models/Invoice'
import { BackButton } from '~/src/components/atoms/Button/BackButton/BackButton'

export const OrderProformaInvoiceDetail: React.FC = (): JSX.Element => {
  const { t } = useTranslation()
  const { id } = useParams()
  const location = useLocation()
  // @ts-ignore
  const invoice = location.state.item as IInvoiceDetail | undefined

  if (!invoice || Number(invoice.id) !== Number(id)) {
    // 直リンクの場合はデータがないのでリストに戻す
    return <Navigate to="/admin/order/proforma-invoice/list" />
  }

  return (
    <ProtectedPage pageTitle={t('proforma_invoice.title')}>
      <BackButton location={location} />
      <ProformaInvoiceForm invoice={invoice} />
    </ProtectedPage>
  )
}
